import React, { useState, useEffect } from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const DefaultHeader = () => {
	const [selectedBranchName, setSelectedBranchName] = useState('');

	useEffect(() => {
		const updateBranchName = () => {
			const branchid = localStorage.getItem('selectedBranch');
			const branchesList = JSON.parse(localStorage.getItem('branches-list'));

			const selectedName = branchesList?.find(
				(branch) => String(branch.value) === String(branchid),
			)?.text;

			setSelectedBranchName(selectedName);
		};

		updateBranchName();

		const handleBranchChange = (e) => {
			if (e?.detail?.name) {
				setSelectedBranchName(e.detail.name);
			} else {
				updateBranchName();
			}
		};

		window.addEventListener('branchChanged', handleBranchChange);

		return () => {
			window.removeEventListener('branchChanged', handleBranchChange);
		};
	}, []);

	return (
		<Header>
			<HeaderLeft>
				{selectedBranchName && (
					<span className='text-muted'>Branch: {selectedBranchName}</span>
				)}
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default DefaultHeader;
